export const COURSE_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  UNKNOWN: 'Unknown',
};
